module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "AHD"
  }, [_c('a', {
    attrs: {
      "id": "Chocolate-Whoopies"
    }
  }), _vm._v("Chocolate Whoopie")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("The original and quintessential whoopie pie.")]), _vm._v(" "), _c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("Ingredients…")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  115g (4oz) soft unsalted (sweet) butter")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  200g (7oz) soft brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  1 large (US extra large) egg")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  5ml (1 tsp) vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  225ml (8 fl oz) buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  60g (2oz) cocoa powder (unsweetened cocoa)")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  5ml (1 tsp) bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  2.5ml ("), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v(" tsp) baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-last"
  }, [_vm._v("•  190g (6"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("oz) plain (all-purpose) flour")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("1")]), _vm._v(" Preheat the oven to 180ºC (350ºF/Gas 4). Grease two whoopie pie tins with a little softened butter.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Sift together the flour, cocoa, baking powder and bicarbonate of soda and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("3")]), _vm._v(" In a separate bowl, cream the butter and sugar together until light and fluffy using an electric whisk or freestanding mixer.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Add the egg and vanilla and beat until well combined.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("5")]), _vm._v(" Fold in half the flour mixture, followed by half the buttermilk. Repeat with remaining ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("6")]), _vm._v(" Drop 1"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v(" tbsp or a level small ice cream scoopful of batter into each well of the tins.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("7")]), _vm._v(" Bake for approximately 12 minutes or until the whoopies feel just firm to the touch. Allow to cool in the tins for five minutes before transferring to a wire rack to cool completely.")]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "TIP-AHD"
  }, [_vm._v("Double Trouble…")]), _vm._v(" "), _c('p', {
    staticClass: "TIP1"
  }, [_vm._v("Add a good handful of chocolate chips to the batter for a decadent double chocolate treat!")])]), _vm._v(" "), _c('p', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/_MG_1295_fmt.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b67ee3b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c04.vue
// module id = 72
// module chunks = 0